import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {DataStorageService} from '../../shared/data-storage.service';
import {Router} from '@angular/router';
import {ErrorClass} from '../../error/error-class';

declare var AesUtil: any;
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import {User} from '../../shared/auth/user';
import {InterceptorUtil} from './InterceptorUtil';
import {LoginService} from '../../login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  url: string;
  user: User;
  requestForSubmit: any;


  constructor(
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private dataStorageService: DataStorageService,
    private router: Router,
    private loginService: LoginService,
    private intercUtil: InterceptorUtil
  ) {
  }

  reqBody: string;
  loginEkpayId: string;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log('AuthInterceptor called...');
    // const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
    const token = localStorage.getItem('authenticationToken');
    //console.log('token... ' + token);
    //console.log('is Content-Type present...0 ' + request.headers.has("Content-Type"));
    //console.log('is Accept present...0 ' + request.headers.has("Accept"));
    //console.log('not a file upload case...' + this.router.url);

    this.user = JSON.parse(localStorage.getItem('sessuser')) as User;
    //console.log('this user is>>>', this.user);

    if (this.router.url != '/login') {
      if (this.user == undefined || this.user == null) {
        // this.localStorage.clear('authenticationToken');
        // this.sessionStorage.clear('authenticationToken');
        // sessionStorage.clear();
        // localStorage.clear();
        this.loginService.logout();
        this.localStorage.clear('authenticationToken');
        this.sessionStorage.clear('authenticationToken');
        this.router.navigate(['/login']);
      }
      // else{
      //     localStorage.setItem("sessuser", JSON.stringify(this.user));
      //     this.dataStorageService.setUserData(this.user);
      // }
    }

    if (request.body != null) {
      //if (this.router.url.includes("/login")) {
      //console.log('processing request >>>>', request.body);
      var str = JSON.stringify(request.body);
      var str1 = str.replace(/\\/g, '');
      if (str1.startsWith('"')) {
        this.reqBody = str1.substring(1, str1.length - 1);
      } else {
        this.reqBody = str1;
      }
      //console.log('>>>>> string version is', this.reqBody);
      var iterationCount = 1000;
      var keySize = 128;
      var aesUtil = new AesUtil(keySize, iterationCount);
      var encString1 = aesUtil.encrypt('8bc82ffe516ea1f1b89dcb529a201d56', 'ebb7947b5feabdc0b60f2a694fa259c4', 'aks@Samuel#Rishi', this.reqBody);
      //console.log('encrypted string is >>>>' + JSON.stringify(encString));
      var encString = '{"mnbvcxzlkjhgfdsapoiuytrewq":"' + encString1 + '"}';
      if (this.router.url == '/agent/merchant-settlement-list') {
        var customReq;
        this.requestForSubmit = request;

        if (this.requestForSubmit.url == '/honcho/agent/file/file-upload') {
          customReq = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token),

          });
        } else {
          customReq = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json'),
            body: encString

          });
        }

        return next.handle(customReq).map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
          return event;
        }).do((ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {

            if (ev.headers.get('Authorization') != null) {
              let ary = [];
              ary = ev.headers.get('Authorization').split(' ');
              this.localStorage.store('authenticationToken', ary[1]);
              localStorage.setItem('authenticationToken', ary[1]);
              // alert(localStorage.getItem('authenticationToken'));
            }
          }
        }, (err: HttpErrorResponse) => {

          if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            //console.log('intercept An error occurred:', err.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            //console.log(`intercept Backend returned code ${err.status}, body was: ${err.error.message}`);
          }
          //console.log(`Backend returned code ${err.status}, body was: ${err.error.message}`);
          this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');

          if (err.status == 401 && err.error.message == 'Access Denied') {
            this.loginService.logout();
            this.localStorage.clear('authenticationToken');
            this.sessionStorage.clear('authenticationToken');
            this.router.navigate(['/login']);
          }
          if (err.status != 401 && err.status != 403 && err.status != 404) {
            this.router.navigate(['/error']);
          }

          if (err.status == 200 && (err.error.text == 'Access Denied... UNAUTHORIZED' || err.error.text == 'Access Denied... Forbidden')) {
            //console.log('Access Denied... UNAUTHORIZED', err.error.text);
            // window.location.href = "http://localhost:4200/#/login";
            this.loginService.logout();
            this.localStorage.clear('authenticationToken');
            this.sessionStorage.clear('authenticationToken');
            this.router.navigate(['/login']);
            // location.reload(true);
            // window.location.href='http://localhost:4200/#/login';
          }
        });


      }


    }

    if (this.router.url == '/report/pm-transaction-data' || this.router.url == '/report/ekdesh-transaction-data') {
      encString = this.reqBody;
    }
    const customRequest = request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json'),
      body: encString

    });


    //console.log('is Content-Type present... ' + customReq.headers.has("Content-Type"));
    //console.log('is Accept present... ' + customReq.headers.has("Accept"));
    //console.log('custom request is >>>>>>>>>>>>>>>', customReq.body);


    //console.log("//     var ciphertext2 = aesUtil.decrypt------2---->",customReq);
    return next.handle(customRequest).map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // change the response body here
        // //console.log('event.body>>', event.body);
        //
        // if (event.body.qwertyuiopasdfghjklzxcvbnm != undefined) {
        //     //console.log('processing response >>>>', JSON.stringify(event.body));
        //     var iterationCount = 1000;
        //     var keySize = 128;
        //     var aesUtil = new AesUtil(keySize, iterationCount);
        //     var ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "aks@Samuel#Rishi", event.body.qwertyuiopasdfghjklzxcvbnm);
        //     //console.log('ciphertext2 is >>>>', ciphertext2);
        //     // return ev.clone({
        //     //     body: ciphertext2
        //     // });
        //     event = event.clone({
        //         body: JSON.parse(ciphertext2)
        //     });
        // }
      }
      return event;
    }).do((ev: HttpEvent<any>) => {
      if (ev instanceof HttpResponse) {

        if (ev.headers.get('Authorization') != null) {
          let ary = [];
          ary = ev.headers.get('Authorization').split(' ');
          this.localStorage.store('authenticationToken', ary[1]);
          localStorage.setItem('authenticationToken', ary[1]);
          // alert(localStorage.getItem('authenticationToken'));
        }
      }
    }, (err: HttpErrorResponse) => {

      if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        //console.log('intercept An error occurred:', err.error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        //console.log(`intercept Backend returned code ${err.status}, body was: ${err.error.message}`);
      }
      //console.log(`Backend returned code ${err.status}, body was: ${err.error.message}`);
      this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');

      if (err.status == 401 && err.error.message == 'Access Denied') {
        this.loginService.logout();
        this.localStorage.clear('authenticationToken');
        this.sessionStorage.clear('authenticationToken');
        this.router.navigate(['/login']);
      }
      if (err.status != 401 && err.status != 403 && err.status != 404) {
        this.router.navigate(['/error']);
      }

      if (err.status == 200 && (err.error.text == 'Access Denied... UNAUTHORIZED' || err.error.text == 'Access Denied... Forbidden')) {
        //console.log('Access Denied... UNAUTHORIZED', err.error.text);
        // window.location.href = "http://localhost:4200/#/login";
        this.loginService.logout();
        this.localStorage.clear('authenticationToken');
        this.sessionStorage.clear('authenticationToken');
        this.router.navigate(['/login']);
        // location.reload(true);
        // window.location.href='http://localhost:4200/#/login';
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/auth.interceptor.ts